import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import qs from 'qs';

import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import IconButton from 'components/common/IconButton';
import Menu, { MenuItem } from 'components/common/Menu';
import IconMoreVert from 'components/icons/IconMoreVert';
import DeleteMenu from 'components/common/DeleteMenu';
import Link from 'components/common/Link';

import splitLongWords from 'utils/splitLongWords';

import { deleteRole } from 'redux/modules/roles';

const styles = () => ({
  iconMoreVert: {
    width: 24,
    height: 24,
  },
  buttonCell: {
    textAlign: 'right',
    padding: '0 10px 0 0',
    '&:last-child': {
      padding: '0 10px 0 0',
    },
  },
  cellName: {
    width: '22%',
  },
});

class RolesTableRow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
      deleteMenuOpen: false,
    };

    this.onMenuButtonClick = this.onMenuButtonClick.bind(this);
    this.onMenuClose = this.onMenuClose.bind(this);
    this.onDeleteMenuItemClick = this.onDeleteMenuItemClick.bind(this);
    this.onDeleteCancel = this.onDeleteCancel.bind(this);
    this.onDeleteSubmit = this.onDeleteSubmit.bind(this);
  }

  onMenuButtonClick(event) {
    this.setState({
      anchorEl: event.currentTarget,
    });
  }

  onMenuClose() {
    this.setState({ anchorEl: null });
  }

  onDeleteMenuItemClick() {
    this.setState({ deleteMenuOpen: true });
  }

  onDeleteCancel() {
    this.setState({ anchorEl: null });
  }

  onDeleteSubmit() {
    const { ID, actions } = this.props;
    actions.deleteRole({ ID });
    this.setState({
      deleteMenuOpen: false,
      anchorEl: null,
    });
  }

  render() {
    const { account, ID, Name, Description, history, classes } = this.props;
    const { anchorEl, deleteMenuOpen } = this.state;
    const open = Boolean(anchorEl);

    return (
      <TableRow>
        <TableCell className={classes.cellPayerName}>
          <Link
            breakWord
            href={`/settings/roles/edit/${ID}`}
          >
            {splitLongWords(Name, 100)}
          </Link>
        </TableCell>
        <TableCell className={classes.cellPayerName}>
          {Description}
        </TableCell>
        <TableCell className={classes.buttonCell}>
          <IconButton
            aria-label="More"
            aria-owns={open ? `${this.props.ID}-role-menu` : null}
            aria-haspopup="true"
            onClick={this.onMenuButtonClick}
            tooltipContent="Open Menu"
          >
            <IconMoreVert className={classes.iconMoreVert} />
          </IconButton>
          <Menu
            id={`${this.props.ID}-role-menu`}
            anchorEl={anchorEl}
            open={open}
            onClose={this.onMenuClose}
            list={!deleteMenuOpen}
            maxHeight={130}
          >
            {deleteMenuOpen ? (
              <DeleteMenu
                text="Are you sure you want to delete this role?"
                onCancel={this.onDeleteCancel}
                onSubmit={this.onDeleteSubmit}
              />
            ) : (
              <Fragment>
                <MenuItem
                  onClick={() => {
                    history.push(`/settings/roles/edit/${ID}`);
                  }}
                >
                  Edit
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    const hrefParams = qs.stringify({ ID: [ID] }, {
                      encode: false, addQueryPrefix: true,
                    });
                    history.push(`/settings/roles/copy${hrefParams}`);
                  }}
                >
                  Model (Copy)
                </MenuItem>
                <MenuItem
                  onClick={this.onDeleteMenuItemClick}
                  color="warning"
                  disabled={account.Roles.filter(item =>
                    item.Name === 'Master Administrator' || item.Name === 'Administrator' || item.Name === 'Manager').length === 0}
                >
                  Delete
                </MenuItem>
              </Fragment>
            )}
          </Menu>
        </TableCell>
      </TableRow>
    );
  }
}

RolesTableRow.propTypes = {
  ID: PropTypes.number.isRequired,
  Name: PropTypes.string.isRequired,
  Description: PropTypes.string,
  actions: PropTypes.shape({
    deleteRole: PropTypes.func.isRequired,
  }).isRequired,
  account: PropTypes.shape({
    Roles: PropTypes.arrayOf(PropTypes.shape({
      Name: PropTypes.string.isRequired,
    })).isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    iconMoreVert: PropTypes.string.isRequired,
    buttonCell: PropTypes.string.isRequired,
    cellName: PropTypes.string.isRequired,
  }).isRequired,
};

RolesTableRow.defaultProps = {
  Description: null,
};

const mapStateToProps = store => ({
  account: store.account,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ deleteRole }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withRouter(withStyles(styles)(RolesTableRow)),
);



// WEBPACK FOOTER //
// ./src/components/settings/RolesTable/RolesTableRow.js